/**
 * WeaponAxe — single-bit war axe.
 * Wide asymmetric blade at the top extending left; curved belly and beard.
 * Renders as an SVG <g> group in the knight's coordinate space (25×25).
 */
export default function WeaponAxe() {
  return (
    <g>
      {/* Blade body (upper) — wide left-swept cutting edge */}
      <path d="M13 1.5 L22.5 5 L22.5 10 L14 7.5 Z"  fill="#b0c4d4"/>
      {/* Blade bevel highlight */}
      <path d="M13.5 2 L22.5 5.3 L22.5 9.2 L14.5 7 Z" fill="#d8ecf8" opacity="0.45"/>
      {/* Beard (lower extension of blade) */}
      <path d="M22.5 9 L22.5 14 L17 11.5 Z"            fill="#9ab4c4"/>
      {/* Blade spine */}
      <path d="M13 1.5 L13 7.8 L14 7.5 L14 1.8 Z"     fill="#8aa0b0" opacity="0.5"/>
      {/* Eye hole in axe head */}
      <ellipse cx="21.2" cy="7.2" rx="1.2" ry="1.4" fill="none" stroke="#6a8898" strokeWidth="0.8"/>
      {/* Haft / handle */}
      <rect x="21"   y="5"  width="2"   height="18"  rx="0.7" fill="#7a5a3a"/>
      {/* Handle grip wraps */}
      <rect x="20.6" y="10" width="2.8" height="0.8" rx="0.3" fill="#9a7a5a" opacity="0.85"/>
      <rect x="20.6" y="15" width="2.8" height="0.8" rx="0.3" fill="#9a7a5a" opacity="0.85"/>
      <rect x="20.6" y="19" width="2.8" height="0.8" rx="0.3" fill="#9a7a5a" opacity="0.85"/>
      {/* Pommel cap */}
      <circle cx="22" cy="23.5" r="1.4" fill="#5a4038" stroke="#8a9ab0" strokeWidth="0.5"/>
    </g>
  );
}
